import React from 'react';
import { HeartCrack } from 'lucide-react';

interface ErrorMessageProps {
  title?: string;
  message: string;
  action?: React.ReactNode;
}

export function ErrorMessage({ 
  title = 'Error', 
  message, 
  action 
}: ErrorMessageProps) {
  return (
    <div className="flex flex-col items-center justify-center py-8 px-4 text-center">
      <div className="w-16 h-16 bg-sky-100 dark:bg-sky-900/20 rounded-full flex items-center justify-center mb-4">
        <HeartCrack className="w-10 h-10 text-sky-600 dark:text-sky-400" />
      </div>
      <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
        {title}
      </h2>
      <p className="text-gray-600 dark:text-gray-400 mb-4 max-w-sm">
        {message}
      </p>
      {action}
    </div>
  );
}